import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogForm from "../../../components/admin/BlogForm";
import { createBlog } from "../../../services/blogService";
import AdminBlogLayout from "./AdminBlogLayout";

const AddBlog = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async (payload) => {
    setSaving(true);
    setError("");
    try {
      const blog = await createBlog(payload);
      navigate(`/admin/blog/edit/${blog.id}`);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not create blog.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminBlogLayout title="Add Blog">
      {error && <div className="mb-6 border border-cynos-red/40 bg-cynos-red/10 p-4 font-mono text-xs uppercase tracking-[0.18em] text-red-200">{error}</div>}
      <BlogForm saving={saving} onSubmit={save} submitLabel="Create Blog" />
    </AdminBlogLayout>
  );
};

export default AddBlog;
